const responseWrap = async (fn, ...params) => {
	const { data } = await fn(...params);
	return data;
};

export const axiosMutationWrapper = (fn) => async (param) => responseWrap(fn, param);

export const axiosQueryWrapper = (fn, ...params) => async () => responseWrap(fn, ...params);
